import { combine, createEventRateLimiter, getRelativeTime } from '@datadog/browser-core';
import { StatusType } from './logger';
export function buildAssemble(sessionManager, configuration, reportRawError) {
  var _a;

  var logRateLimiters = (_a = {}, _a[StatusType.error] = createEventRateLimiter(StatusType.error, configuration.eventRateLimiterThreshold, reportRawError), _a[StatusType.warn] = createEventRateLimiter(StatusType.warn, configuration.eventRateLimiterThreshold, reportRawError), _a[StatusType.info] = createEventRateLimiter(StatusType.info, configuration.eventRateLimiterThreshold, reportRawError), _a[StatusType.debug] = createEventRateLimiter(StatusType.debug, configuration.eventRateLimiterThreshold, reportRawError), _a['custom'] = createEventRateLimiter('custom', configuration.eventRateLimiterThreshold, reportRawError), _a);
  return function (message, currentContext) {
    var _a, _b;

    var startTime = message.date ? getRelativeTime(message.date) : undefined;
    var session = sessionManager.findTrackedSession(startTime);

    if (!session) {
      return undefined;
    }

    var contextualizedMessage = combine({
      service: configuration.service,
      session_id: session.id
    }, currentContext, getRUMInternalContext(startTime), message);

    if (((_a = configuration.beforeSend) === null || _a === void 0 ? void 0 : _a.call(configuration, contextualizedMessage)) === false || ((_b = logRateLimiters[contextualizedMessage.status]) !== null && _b !== void 0 ? _b : logRateLimiters['custom']).isLimitReached()) {
      return undefined;
    }

    return contextualizedMessage;
  };
}
export function getRUMInternalContext(startTime) {
  var rum = window.DD_RUM;
  return rum && rum.getInternalContext ? rum.getInternalContext(startTime) : undefined;
}